import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'gen-statistics-control',
  templateUrl: './statistics-control.component.html',
  styleUrls: ['statistics-control.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush

})
export class StatisticsControlComponent {
  @Input() filter: any;
  @Input() indexOfelement: any;

}
